import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";
import { loadOssLicenses } from "src/services/ossLicensesService";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { Box, Typography } from "@mui/material";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { LoadingIcon } from "@shared/Loading";

import { useStyles } from "./OssLicensesPage.style";

const OssLicensesPage = () => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);
    const [licenses, setLicenses] = React.useState<string | null>(null);
    const [loadFailed, setLoadFailed] = React.useState(false);

    React.useEffect(() => {
        let cancelled = false;

        void loadOssLicenses()
            .then((content) => {
                if (!cancelled) {
                    setLicenses(content);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setLoadFailed(true);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <PageContainer scrollable>
            <Box className={classes.content}>
                <Typography variant="h4" component="h1">
                    {t("pages:ossLicensesPage.title")}
                </Typography>

                {licenses === null && !loadFailed ? (
                    <Box className={classes.stateBox}>
                        <LoadingIcon size="block" />
                    </Box>
                ) : null}

                {loadFailed ? <Typography color="error">{t("pages:ossLicensesPage.loadError")}</Typography> : null}

                {licenses ? (
                    <Box component="pre" className={classes.licenseText}>
                        {licenses}
                    </Box>
                ) : null}
            </Box>
        </PageContainer>
    );
};

export default withMetaDescription(OssLicensesPage, {
    title: i18next.t("pages:ossLicensesPage.metaTitle"),
});
